import * as React from 'react'
import { useLocation, useNavigate } from 'react-router'
import { ToggleButton } from '@mfaindex/ui'
import { FilterPanel } from '~/components/ui/FilterPanel'
import { useIndexContext } from '~/hooks/useIndexContext'

export type Props = {
  className?: string,
}

export const SchoolFilters = ({ className }: Props) => {
  const index = useIndexContext()
  const { filters, schools } = index

  // Toggle buttons
  const location = useLocation()
  const navigate = useNavigate()

  const toggle = (slug: string) => {
    const params = new URLSearchParams(location.search)
    if (!params.getAll('school').includes(slug)) {
      params.append('school', slug)
    }
    else {
      const currentFilters = params.getAll('school')
      params.delete('school')
      currentFilters.forEach(s => {
        if (s !== slug) params.append('school', s)
      })
    }

    const querystring = `?${params.toString()}`
    navigate({
      pathname: location.pathname,
      search: querystring === '?' ? undefined : querystring,
    })
  }

  const onClick = (slug: string) => (e: React.MouseEvent) => {
    e.preventDefault()
    toggle(slug)
  }

  return (
    <FilterPanel className={className}>
      {schools.map(school => (
        <ToggleButton
          key={school.id}
          isChecked={filters.school.has(school.slug)}
          onClick={onClick(school.slug)}
          as={p => <a {...p} href={`${location.pathname}?school=${school.slug}`} />}
        >
          {school.shortName}
        </ToggleButton>
      ))}
    </FilterPanel>
  )
}

export default SchoolFilters
